import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IMenuFilter {
  execute(menuList: any): Observable<any>;
}

export const MENU_FILTERS = new InjectionToken<IMenuFilter>('direct.menu.filters');
